export const sitemap = {
  column_1: [
    { de: { name: 'Agentur', to: '/agentur' }, en: { name: 'agency', to: '/agentur' } },
    { de: { name: 'Expertise', to: '/expertise' }, en: { name: 'services', to: '/expertise' } },
    { de: { name: 'Cases', to: '/cases' }, en: { name: 'cases', to: '/cases' } },
    { de: { name: 'Jobs', to: '/jobs' }, en: { name: 'jobs', to: '/jobs' } }
  ],
  column_2: [
    { de: { name: 'Blog', to: '/blog' }, en: { name: 'blog', to: '/blog' } },
    { de: { name: 'Impressum', to: '/impressum' }, en: { name: 'imprint', to: '/impressum' } },
    { de: { name: 'Datenschutz', to: '/datenschutz' }, en: { name: 'data privacy', to: '/datenschutz' } }
    // { de: { name: 'Cookies', to: '/cookies' }, en: { name: 'cookies', to: '/cookies' } }
  ]
}
